
import { useState, useEffect } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { StudentFormValues } from "../schema/studentSchema";
import { UseFormReturn } from "react-hook-form";

export const useStudentData = (id: string | undefined, form: UseFormReturn<StudentFormValues>) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchStudent = async () => {
      if (!id) return;

      try {
        setIsLoading(true);
        console.log("Fetching student data for id:", id);
        const { data, error } = await supabase
          .from("students")
          .select("*")
          .eq("id", id)
          .single();

        if (error) throw error;

        if (data) {
          console.log("Student data fetched:", data);
          const formData: StudentFormValues = {
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            phone: data.phone || "",
            birth_date: data.birth_date || "",
            height: data.height?.toString() || "",
            weight: data.weight?.toString() || "",
            medical_conditions: data.medical_conditions || "",
            emergency_contact: data.emergency_contact || "",
            preferred_training_time: data.preferred_training_time as "manha" | "tarde" | "noite" | undefined,
            fitness_level: data.fitness_level as "iniciante" | "intermediario" | "avancado" | undefined || "iniciante",
            initial_assessment_date: data.initial_assessment_date || "",
            initial_assessment_notes: data.initial_assessment_notes || "",
            preferred_training_type: data.preferred_training_type as "musculacao" | "funcional" | "cardio" | "hiit" | "pilates" | undefined,
            goals: data.goals || "",
            notes: data.notes || "",
            monthly_fee: data.monthly_fee?.toString() || "",
            payment_status: data.payment_status as "pago" | "pendente" | "atrasado" | undefined,
            payment_method: data.payment_method as "transferencia" | "dinheiro" | "cartao" | "debito_direto" | undefined,
            payment_notes: data.payment_notes || "",
            has_schedule_access: data.has_schedule_access !== undefined ? data.has_schedule_access : true,
            send_account_email: true // This won't be used in edit mode anyway
          };
          form.reset(formData);
        }
      } catch (error: any) {
        console.error("Error fetching student:", error);
        toast.error("Erro ao carregar dados do aluno");
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudent();
  }, [id, form]);

  return { isLoading };
};
